export const READ_SINGLE_NOTIFICATION_START = 'READ_SINGLE_NOTIFICATION_START';

export const READ_SINGLE_NOTIFICATION_SUCCESS = 'READ_SINGLE_NOTIFICATION_SUCCESS';

export const READ_SINGLE_NOTIFICATION_FAILURE = 'READ_SINGLE_NOTIFICATION_FAILURE';
